module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_smaller-cb9072a13570c9772c2cefce415f72d8.svg";